import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';
import { setupWebFontConfig } from 'bog-arcade-core-ui/helpers';

import { FONT_BALOO_NAME, FONT_LATO_NAME } from '../core/constats';

import { GameMobileDrawer } from './drawers/GameMobileDrawer';

import { GameApplicationType, GameSceneType } from '../core/enums';
import { mobileConfig, webConfig } from '../core/applicationConfig';
import { backgroundDrawer } from '../elementDrawers/background/BackgroundDrawer';
import { ballDrawer } from '../elementDrawers/balls/BallDrawer';
import { gamePad } from '../elementDrawers/gamePad/GamePadDrawer';
import { bonusBoardDrawer } from '../elementDrawers/bonusBoard/BonusBoardDrawer';
import { GAME_APPLICATION_TYPE_STATE } from '../stateManagment';
import { congratulationsPopup } from '../elementDrawers/congratulationPopup/CongratulationsPopupDrawer';
import { buyBonus } from '../elementDrawers/buyBonusPopup/BuyBonusPopup';
import { bigWinPopup } from '../elementDrawers/bigWinPopup/BigWinPopupDrawer';
import { GameWebDrawer } from './drawers/GameWebDrawer';
import { gamePadService } from '../services/helperServices/GamePadService';
import { GameLandscapeDrawer } from './drawers/GameLandscapeDrawer';
import { iframeService } from '../services/helperServices/IframeService';
import { soundService } from '../services/helperServices/SoundService';

export class GameDrawer extends DrawerBase {
  constructor(applications) {
    super();
    this.applications = applications;
    this.mobile = this.createApplication(mobileConfig.config);
    this.desktop = this.createApplication(webConfig.config);
    this.landscape = this.createApplication(webConfig.config);
    this.loader = this.createLoader();
    this.applications[GameApplicationType.mobile].defineParent(this.mobile.stage);
    this.applications[GameApplicationType.web].defineParent(this.desktop.stage);
    this.applications[GameApplicationType.landscape].defineParent(this.landscape.stage);
    this.fontLoaded = false;
  }

  static resources = null;

  get parent() {
    const gameMode = GAME_APPLICATION_TYPE_STATE.getValue();
    switch (gameMode) {
      case GameApplicationType.web:
        return this.desktop;
      case GameApplicationType.mobile:
        return this.mobile;
      case GameApplicationType.landscape:
        return this.landscape;
      default:
        return this.mobile;
    }
  }

  async loadFonts() {
    if (this.fontLoaded) {
      return this.fontLoaded;
    }

    return new Promise((resolve) => {
      window.WebFontConfig = {
        google: {
          families: [`${FONT_BALOO_NAME}:700`, `${FONT_LATO_NAME}`],
        },
        active() {
          resolve(true);
        },
      };
      setupWebFontConfig();
    });
  }

  get application() {
    return this.applications[GAME_APPLICATION_TYPE_STATE.getValue()];
  }

  execute(root) {
    gamePadService.disableAll();
    this.loadResource([], this.createLoader()).then(() => {
      if (!root.children.length) {
        root.appendChild(this.parent.view);
      }
      iframeService.sendLoadedState();
    });
  }

  modeChange({ mode, scene, prevScene }) {
    if (scene === GameSceneType.main) {
      soundService.playMainSceneBackground();
    } else {
      soundService.playBonusSceneBackground();
    }
    this.loadFonts().then(() => {
      this.fontLoaded = true;
      this.applications[mode].execute({ scene, parent: this.parent.stage, prevScene });
    });
  }
}

const drawers = {
  background: backgroundDrawer,
  balls: ballDrawer,
  gamePad: gamePad,
  bonusBoard: bonusBoardDrawer,
  buyBonus: buyBonus,
  congratulationsPopup: congratulationsPopup,
  bigWin: bigWinPopup,
};

export const gameDrawer = new GameDrawer({
  [GameApplicationType.mobile]: new GameMobileDrawer(drawers),
  [GameApplicationType.web]: new GameWebDrawer(drawers),
  [GameApplicationType.landscape]: new GameLandscapeDrawer(drawers),
});
